<template>
  <div :class="`d-flex ${vertical ? 'flex-column' : ''}`">
    <v-icon
      color="primary"
      @click="$emit('update:is-configurar-celula-dialog-open', !isConfigurarCelulaDialogOpen)"
    >
      {{ icons.mdiCog }}
    </v-icon>

    <v-icon
      v-if="podeDeletar"
      :class="`${vertical ? 'mt-2' : 'ml-1'}`"
      color="error"
      @click="$emit('update:is-deletar-componente-dialog-open', !isDeletarComponenteDialogOpen)"
    >
      {{ icons.mdiDelete }}
    </v-icon>
  </div>
</template>

<script>
import { mdiCog, mdiDelete } from '@mdi/js'

export default {
  props: {
    isConfigurarCelulaDialogOpen: {
      type: Boolean,
      required: true,
    },
    isDeletarComponenteDialogOpen: {
      type: Boolean,
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    podeDeletar: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    return {
      icons: {
        mdiCog,
        mdiDelete,
      },
    }
  },
}
</script>
